import { TextField } from "@material-ui/core";
import React, { Component } from "react";

class SearchInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      TimeoutID: 0,
    };
  }

  OnChange(e) {
    clearTimeout(this.state.TimeoutID);

    const TimeoutID = setTimeout(() => {
      this.props.UpdateSearchValue(this.state.value);
    }, 3000);

    this.setState({ value: e.target.value, TimeoutID: TimeoutID });
  }

  OnEnter(e) {
    if (e.key == "Enter") {
      clearTimeout(this.state.TimeoutID);

      this.props.UpdateSearchValue(this.state.value);
    }
  }

  render() {
    return (
      <TextField
        label={"Zoeken"}
        variant="outlined"
        value={this.state.value}
        onChange={(e) => this.OnChange(e)}
        onKeyDown={(e) => this.OnEnter(e)}
        style={{ width: "100%" }}
      />
    );
  }
}

export default SearchInput;
